import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory } from 'react-router';

export default class NewManagerAccountsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            usersData: null,
        }

        this.index = 0;
    }

    componentDidMount() {
        //TODO: add API
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    didSelectRow(row) {
        browserHistory.push('/admin/users/' + row.tenant_id);
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    render(){
        var self = this;
        var usersData = this.state.usersData;

        if (usersData != null) {
            usersData = usersData.map(function(user) {
                return self.flattenObject(user);
            });
        }

        const options = {
            onRowClick: this.didSelectRow
        };

        return (
            <div class="row">
                <div class="content">
                {usersData != null ? (
                    <BootstrapTable data={usersData} version='4' striped search pagination hover options={options}>
                        <TableHeaderColumn dataField='' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={true}></TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataSort={ true }>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataSort={ true }>Billing Status</TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataSort={ true }>Subscription</TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataSort={ true }>Created</TableHeaderColumn>
                    </BootstrapTable>
                ) : (
                    <p>No new manager accounts.</p>
                )}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/components/Admin/Users/NewManagerAccountsList.jsx